import React, { useState, useEffect } from "react";
import { Tooltip } from "antd";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Leftarrow from "../../assets/images/Leftarrow.svg";
import "./FooterPDFViewer.scss";
import "./terms-and-conditions.scss";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;


const FooterPDFViewer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { slug, id: footerDocId } = useParams();

  const { state } = location;
  const { partnerId } = useSelector((state) => state?.localStorage);
  const [numPages, setNumPages] = useState(0);
  const [selectedFooterData, setSelectedFooterData] = useState(null);

  const fetchFooterDocuments = async () => {
    try {
      const response = await getRequest(
        userapiservice.fetchFooterDocuments(partnerId),
      );
      console.log("fetchFooterDocuments====>",response);
      if (response) {
        const footerDataById = response?.find(
          (item) => item?.id === footerDocId,
        );
        setSelectedFooterData(footerDataById);
      } else {
        toast.error("Something went wrong!")
      }
    } catch (error) {
      toast.error(error);
    }
  };

  useEffect(() => {
    if (partnerId) {
      console.log('partnerId----->', partnerId);
      fetchFooterDocuments();
    }
  }, [partnerId, footerDocId]);

  const handleBack = () => {
    if (window.history.state && window.history.state.idx > 0) {
      navigate(-1);
    } else {
      navigate("/frontend", {
        state: {
          data: state?.formData,
        },
      });
    }
  };

  return (
    <motion.div
      className="terms-and-conditions-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="container footer-pdf-viewer-container">
        <div className="apply-header" style={{ width: "100%" }}>
          <div>
            <Tooltip title="Go back">
              <img
                className="back-btn"
                src={Leftarrow}
                onClick={handleBack}
                alt="back button"
              />
            </Tooltip>
          </div>

          <div>
            <h2>{selectedFooterData?.title}</h2>
          </div>

          <div />
        </div>

        {selectedFooterData?.fileUrl && (
          <div
            style={{
              width: "100%",
              height: "65vh",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Document
                file={selectedFooterData?.fileUrl}
                onLoadSuccess={({ numPages }) => {
                  setNumPages(numPages);
                }}
                onLoadError={(error) => {
                  console.error("PDF Load Error:", error);
                }}
              >
                {Array.from({ length: numPages }, (_, index) => (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      marginBottom: "20px",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Page
                      pageNumber={index + 1}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                    />
                  </div>
                ))}
              </Document>
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default FooterPDFViewer;
